import { isRouteErrorResponse, useRouteError, Link } from 'react-router';
import { ROUTES } from '@/lib/routes';

export function RouteErrorBoundary() {
  const error = useRouteError();

  let title = 'Something went wrong';
  let message = 'An unexpected error occurred. Please try again.';

  if (isRouteErrorResponse(error)) {
    title = `${String(error.status)} — ${error.statusText}`;
    message =
      typeof error.data === 'string' ? error.data : 'The requested page could not be loaded.';
  }

  return (
    <div style={{ padding: '48px 32px', textAlign: 'center' }}>
      <h1 style={{ fontSize: 'var(--text-2xl)', marginBottom: 8 }}>{title}</h1>
      <p style={{ color: 'var(--text-secondary)', marginBottom: 24 }}>{message}</p>
      <Link to={ROUTES.APP} style={{ color: 'var(--text-link)', textDecoration: 'none' }}>
        Go home
      </Link>
    </div>
  );
}
